import { useSelector } from 'react-redux'
import { AccountForFront } from '@mutual-services/pj-panel-types'
import { ReduxState } from '../store'

export const useAuthAccount = (): AccountForFront => {
  const authAccount = useSelector<ReduxState, AccountForFront | null>((state) => state.auth.account)

  return authAccount!
}
